import React from 'react';
// Core components
import TextField from 'components/core/TextField';
// Custom
import { DisplayIconButton, HideIconButton } from 'components/buttons/IconButtons';

const PasswordInputField = (props) => {
  // Manage visible status
  const [visible, setVisible] = React.useState(false);
  const handleSetVisible = () => {
    setVisible(!visible);
  };

  return (
    <TextField
      type={visible ? 'text' : 'password'}
      adornments={{
        end: visible
          ? <HideIconButton onClick={handleSetVisible} />
          : <DisplayIconButton onClick={handleSetVisible} />,
      }}
      {...props}
    />
  );
};

module.exports = PasswordInputField;



// WEBPACK FOOTER //
// ./components/inputFields/PasswordInputField.js